$(document).ready(function() {
  var $slider = $('.bkb-slick-slider-init');

  if ($slider.length > 0) {
    $slider.slick({
      arrows: true,
      infinite: false,
      prevArrow:'<button type="button" class="slick-prev pull-left"><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.53125 6.46875C7.8125 6.78125 7.8125 7.25 7.53125 7.53125L1.53125 13.5312C1.21875 13.8438 0.75 13.8438 0.46875 13.5312C0.15625 13.25 0.15625 12.7812 0.46875 12.5L5.9375 7.03125L0.46875 1.53125C0.15625 1.25 0.15625 0.78125 0.46875 0.5C0.75 0.1875 1.21875 0.1875 1.5 0.5L7.53125 6.46875Z" fill="#010101" style="fill:#010101;fill:color(display-p3 0.0039 0.0039 0.0039);fill-opacity:1;"/></svg></button>',
      nextArrow:'<button type="button" class="slick-next pull-right"><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.53125 6.46875C7.8125 6.78125 7.8125 7.25 7.53125 7.53125L1.53125 13.5312C1.21875 13.8438 0.75 13.8438 0.46875 13.5312C0.15625 13.25 0.15625 12.7812 0.46875 12.5L5.9375 7.03125L0.46875 1.53125C0.15625 1.25 0.15625 0.78125 0.46875 0.5C0.75 0.1875 1.21875 0.1875 1.5 0.5L7.53125 6.46875Z" fill="#010101" style="fill:#010101;fill:color(display-p3 0.0039 0.0039 0.0039);fill-opacity:1;"/></svg></button>',
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2
          },
        },
        {
          breakpoint: 499,
          settings: {
            slidesToShow: 1
          },
        },
      ],
    });
  }
});

// javascript

// Close cart On ESC
document.addEventListener('keydown', function(event) {
  if (event.key === 'Escape') {
    const cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');
    
    if (cartDrawer && cartDrawer.classList.contains('drawer--visible')) {
      const cartDrawerClose = cartDrawer.querySelector('.drawer__top button.drawer__close');
      
      if (cartDrawerClose) {
        cartDrawerClose.click(); 
      }
    }
  }
});

// on variant change event
document.addEventListener('theme:variant:change', function(event) {
  const variant = event.detail.variant;
  const sourceEl = event.target;
  // console.log(variant);
  
  if (!variant) return;
 
  if (sourceEl.closest('.quickview__form') || sourceEl.closest('[data-quickview-form-area]')) {
      //For Quick Form
      // console.log('Triggered from QUICK VIEW');

      const productElement = event.target.closest('[data-product-handle]');
      const handle = productElement?.getAttribute('data-product-handle');

      // quick-view-product
      fetch(`/products/${handle}?section_id=api-product-quickview&variant=${variant.id}`)
      .then(response => response.text())
      .then(html => {
        loadedDomEL = sourceEl.closest('.quickview__form');
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;

        // console.log(tempDiv);
        const updatedSubscription = tempDiv.querySelector('#shopify-section-api-product-quickview .quickview__form .product__block__subscription .product__block__subscription_inner_wrraper');

        // ->  OnetimePurchase
        const updatedOneTimeSubscriptionPrice = tempDiv.querySelector('#shopify-section-api-product-quickview .quickview__form .product__block__subscription label.onetime_purchase .price_wrraper');
        const oneTimeSubscriptionPrice = loadedDomEL.querySelector('.product__block__subscription label.onetime_purchase .price_wrraper');

        if ( updatedOneTimeSubscriptionPrice && oneTimeSubscriptionPrice ) {                   
          const parentNode = oneTimeSubscriptionPrice.parentNode;
          const updatedOneTimeSubscriptionPriceParent = updatedOneTimeSubscriptionPrice.parentNode;
          const updatedOneTimeSubscriptionPriceNode = updatedOneTimeSubscriptionPriceParent.removeChild(updatedOneTimeSubscriptionPrice);          
          parentNode.replaceChild(updatedOneTimeSubscriptionPriceNode, oneTimeSubscriptionPrice);
        }

        // -> Susbscription Purchase Plan
        // Find the original and updated price containers
        const parentOfPurchasebleLabel = loadedDomEL.querySelector('.product__block__subscription .product__subs__group div.product__subs__plans');
        const updatedParentOfPurchasebleLabel = tempDiv.querySelector('.product__block__subscription .product__subs__group div.product__subs__plans');

        // If both exist, update price blocks
        if (parentOfPurchasebleLabel && updatedParentOfPurchasebleLabel) {
          const newLabels = Array.from(updatedParentOfPurchasebleLabel.children);
          const oldLabels = Array.from(parentOfPurchasebleLabel.children);

          newLabels.forEach((newLabel, index) => {
            const updatedPriceBlock = newLabel.querySelector('.price_wrraper');
            const oldPriceBlock = oldLabels[index]?.querySelector('.price_wrraper');

            if (updatedPriceBlock && oldPriceBlock) {
              // Replace old price block with new one
              const parentNode = oldPriceBlock.parentNode;
              const updatedNode = updatedPriceBlock.cloneNode(true); // clone to detach from tempDiv
              parentNode.replaceChild(updatedNode, oldPriceBlock);
            }
          });
        }

      });
    
  }else {
    if (sourceEl.closest('.product__main__content') || sourceEl.closest('.product__inner ')) {
      // single product page
      // console.log('fetch data from single product page');
      const sectionId = 'template--25941842362680__main'; // ID used in the subscription section
      const subscriptionSelector = document.querySelector('.product__main__content .product__block__subscription');

      const urlParams = new URLSearchParams(window.location.search);
      const variantId = urlParams.get('variant');
      const sellingPlanId = urlParams.get('selling_plan');


      // fetch(`${window.location?.pathname||""}?section_id=${sectionId}&variant=${variant.id}`)
      let fetchUrl = `${window.location.pathname}?section_id=${sectionId}`;

      if(variant.id){
        fetchUrl += `&variant=${variant.id}`;
      }
      

      if (sellingPlanId) {
        fetchUrl += `&selling_plan=${sellingPlanId}`;
      }

      // console.log(fetchUrl);
      
      fetch(fetchUrl)
      .then(response => response.text())
      .then(html => {
         
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        
        const updatedSubscription = tempDiv.querySelector('.product__main__content .product__block__subscription .product__block__subscription_inner_wrraper');
         console.log(updatedSubscription);

        // ->  OnetimePurchase
        const updatedOneTimeSubscriptionPrice = tempDiv.querySelector('.product__main__content .product__block__subscription  label.onetime_purchase .price_wrraper');
        const oneTimeSubscriptionPrice = document.querySelector('.product__main__content .product__block__subscription  label.onetime_purchase .price_wrraper');

        if ( updatedOneTimeSubscriptionPrice && oneTimeSubscriptionPrice ) {          
          const parentNode = oneTimeSubscriptionPrice.parentNode;
          const updatedOneTimeSubscriptionPriceParent = updatedOneTimeSubscriptionPrice.parentNode;
          const updatedOneTimeSubscriptionPriceNode = updatedOneTimeSubscriptionPriceParent.removeChild(updatedOneTimeSubscriptionPrice);          
          parentNode.replaceChild(updatedOneTimeSubscriptionPriceNode, oneTimeSubscriptionPrice);
        }

        // // -> Susbscription Purchase Plan
        const subscriptionPlanGroup = document.querySelectorAll('.product__main__content  .product__block__subscription .plandata_product__subs__group');
        const updatedSubscriptionPlanGroup = tempDiv.querySelectorAll('.product__block__subscription .plandata_product__subs__group');

        // console.log(subscriptionPlanGroup);
        // console.log( updatedSubscriptionPlanGroup);

        subscriptionPlanGroup.forEach( (element, index) => {
          
            const updatedSubscriptionPlanLable = Array.from(updatedSubscriptionPlanGroup[index].children);
            const subscriptionPlanLabel = Array.from(element.children);
            if(updatedSubscriptionPlanLable && subscriptionPlanLabel ){            
              // Find the original and updated price containers
              updatedSubscriptionPlanLable.forEach((newLabel, index) => {
                const updatedPriceBlock = newLabel.querySelector('.price_wrraper');
                const oldPriceBlock = subscriptionPlanLabel[index]?.querySelector('.price_wrraper');

                if (updatedPriceBlock && oldPriceBlock) {
                  // Replace old price block with new one
                  const parentNode = oldPriceBlock.parentNode;
                  const updatedNode = updatedPriceBlock.cloneNode(true); // clone to detach from tempDiv
                  parentNode.replaceChild(updatedNode, oldPriceBlock);
                }
              });
          }      
         
        });
     
      });   
  
    
    } else {
      // console.log('Triggered from unknown');
    }
  }
});